
import { defineComponent, PropType, computed } from "vue";
import TableHeader from "./TableHeader.vue";
import TableRows from "./TableRows.vue";

type SortBy = { sortColumn: string; sortType: "asc" | "desc" };

export default defineComponent({
  name: "DataTable",
  components: { TableHeader, TableRows },
  props: {
    routeKey: { type: String, required: true },
    mapping: { type: Object as PropType<any>, required: true },
    items: { type: Array as PropType<any[]>, required: true },
    sortBy: { type: Object as PropType<SortBy>, required: false },
    pagination: { type: Object as PropType<any>, required: false },
  },
  emits: ["sort", "open-modal", "delete", "move-up", "move-down", "row-action"],
  setup(props, { emit }) {
    const hasActions = computed(() => {
      const a = props.mapping?.Actions;
      const rowButtons = props.mapping?.RowButtons;
      return Boolean(
        a?.editLink || a?.pageLink || a?.deleteLink || a?.inactiveLink || (rowButtons && rowButtons.length)
      );
    });


    const onSort = (columnName: string) => emit("sort", columnName);

    return { hasActions, onSort };
  },
});
